import Event from '../../core/Event';

export default class DataExportRequested extends Event {
    public static type = 'DataExportRequested';

    constructor() {
        super(DataExportRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/products/events/DataExportRequested.ts